const relacao_de_alunos_com_matriculas_canceladas = [
  {
    path: "/relacao-de-alunos-com-matriculas-canceladas",
    redirect: "/relacao-de-alunos-com-matriculas-canceladas",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/relacao-de-alunos-com-matriculas-canceladas",
        name: "relacao_de_alunos_com_matriculas_canceladas",
        component: () =>
          import(
            "@/views/RelacaoDeAlunosComMatriculasCanceladas/RelacaoDeAlunosComMatriculasCanceladasHome.vue"
          ),
      },
    ],
  },
];

export { relacao_de_alunos_com_matriculas_canceladas };
